const API_BASE = process.env.VUE_APP_API_BASE ?? "https://b2b-portal-backend-sandbox-ipzemhvfuq-rj.a.run.app/b2b-portal/api/v1";

export default API_BASE;
